import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import QrCode from 'client/components/QrCode';

function LineLiffQrCode({ url, description = i18n.t('label.login.scan_qrcode_line') }) {
    return (
        <>
            <Typography variant="caption" css={textStyle}>
                {description}
            </Typography>
            <div css={containerStyle}>
                {Boolean(url) && (
                    <QrCode
                        code={url}
                        loadingComp={<Skeleton variant="rect" css={qrCodeStyle} />}
                        css={qrCodeStyle}
                        qrCodeConfig={{ width: 180 }}
                    />
                )}
            </div>
        </>
    );
}

LineLiffQrCode.propTypes = {
    url: PropTypes.string,
    description: PropTypes.string
};

export default LineLiffQrCode;

const textStyle = css`
    padding-bottom: 8px;
`;

const containerStyle = css`
    position: relative;
`;

const qrCodeStyle = css`
    margin: 0 auto;
    max-width: 200px;
    padding: 0 8px;
`;
